import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    query: String
  }

  submit(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'search', {
        search_term: this.queryValue || event.target.value
      })
    }
  }

  resultClick(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'search_result_click', {
        search_term: this.queryValue,
        result_id: event.target.dataset.resultId,
        result_name: event.target.dataset.resultName
      })
    }
  }
}